import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'stx-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule],
  host: { class: 'flex flex-col h-full' },
  template: `<router-outlet />`
})
export class AppComponent {
  protected title = 'check-in';
}
